import nacl from "tweetnacl";
import { deriveNonce } from './deriveNonce';
import { deriveSharedSecret } from './deriveSharedSecret';
import { generateEphemeralKeypair } from './generateEphemeralKeypair';
import { deriveSharedSecretHint } from './deriveSharedSecretHint';

export function createEphemeralEncryptionContext(receiverViewPublicKey: Uint8Array) {
  const { publicKey, privateKey } = generateEphemeralKeypair();
  const sharedSecret = deriveSharedSecret(privateKey, receiverViewPublicKey);
  const sharedSecretHint = deriveSharedSecretHint(sharedSecret);
  const nonce = deriveNonce(publicKey);

  return {
    ephemeralPrivateKey: privateKey,
    ephemeralPublicKey: publicKey,
    sharedSecret,
    sharedSecretHint,
    nonce,
  };
}